export default __webpack_public_path__ + "static/media/3.0ecdf1e1.jpg";